export default function ConfirmChildModal({ showModal, onYes, onNo, childCount }) {
    if (!showModal) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content confirm-modal">
                <h3>Création d'enfants</h3>
                <p>
                    {childCount === 0
                        ? "Voulez-vous créer un enfant ?"
                        : `Enfant ${childCount} créé. Voulez-vous en créer un autre ?`}
                </p>
                <div className="modal-buttons">
                    <button className="green-button" onClick={onYes}>
                        <i className="fa fa-check"></i> Oui
                    </button>
                    <button className="blue-button" onClick={onNo}>
                        <i className="fa fa-arrow-right"></i> Non, passer au gestionnaire
                    </button>
                </div>
            </div>
        </div>
    );
}

